import {makeStyles} from '@logistics-frontend/blocks'
import {theme} from '@logistics-frontend/blocks/lpc/theme'
import TrustSDK from '@yandex-trust-sdk/base'
import {PaymentFrame} from '@yandex-trust-sdk/base/dist-cjs/methods/payment-form'
import {
  FrameMessageAbort,
  FrameMessageError,
  FrameMessageSuccess,
  FrameMessageType,
} from '@yandex-trust-sdk/base/dist-cjs/types'
import React, {useEffect, useRef, useState} from 'react'

import {useConfig} from 'src/config'

type Props = {
  onSuccess: (msg: FrameMessageSuccess) => void
  onAbort: (msg: FrameMessageAbort) => void
  onError: (msg: FrameMessageError) => void
}

const useClasses = makeStyles({
  root: {
    '& iframe': {
      border: 'none',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        height: 380,
      },
      height: '350px',
    },
    minHeight: 360,
  },
})

const AddPaymentFrame: React.FC<Props> = ({onAbort, onError, onSuccess}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [frame, setFrame] = useState<PaymentFrame>()
  const classes = useClasses()
  const apiHost = useConfig().trust.host

  useEffect(() => {
    TrustSDK.create({apiHost})
      .bindCard({mode: 'spin'})
      .then(setFrame)
      .catch((e: Error) =>
        onError({
          reason: e.message,
          type: FrameMessageType.error,
        }),
      )
  }, [apiHost, onError])

  useEffect(() => {
    const element = ref.current

    if (element && frame) {
      // Подписываемся на события привязки
      frame.on('success', onSuccess)
      frame.on('error', onError)
      frame.on('abort', onAbort)

      // Монтируем фрейм в DOM
      frame.mount(element)

      return () => {
        frame.unmount()
      }
    }
  }, [frame, onAbort, onError, onSuccess])

  return <div ref={ref} className={classes.root} />
}

export default AddPaymentFrame
